/**
 * Calculates the YIQ contrast to determine if text should be black or white
 * based on the given hex background color.
 * @param {string} hexcolor - The hex color (e.g. "#ffffff" or "ffffff")
 * @returns {string} - "#000000" (black) or "#ffffff" (white)
 */
export const getContrastYIQ = (hexcolor) => {
    if (!hexcolor) return '#000000';

    // Normalize hex
    let hex = hexcolor.replace('#', '');
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? '#000000' : '#ffffff';
};
